import ActionsForm from '@/shared/mixins/actionsForm'
import {mask} from 'vue-the-mask'
import { toast, loading } from '@/shared/utils/UIHelper'
import AccrediteddateRepository from '@/shared/http/repositories/realestate/accrediteddate'
import state from '@/shared/http/repositories/geo/state'
import axios from 'axios'
export default {
  mixins: [ActionsForm],
  name: 'Newaccredited',

  data () {
    return {

      newAccreditedData: {
        Nome: '',
        EmailComercial: '',
        TelefoneComercial: '',
        DataCadastro: null,
        CRECI: '',
        CRECIUF: '',
        cep: '',
        CidadeNome: '',
        Endereco: '',
        Bairro: '',
        Numero: '',
        PercentualComissao: ''
      },
      statesAcronym: []
    }
  },
  directives: {mask},
  mounted () {
    state.GetAllByCountryID('2375E209-7451-4A7A-A9BE-66BD2C392BE1')
      .then((res) => {
        let stateCompleteData = res.data.data
        stateCompleteData.forEach(stateData => {
          this.statesAcronym.push({value: stateData.sigla, text: stateData.sigla})
        })
      })
      .catch(() => {})
  },
  methods: {
    openAddNewAccreditedModal () {
      this.$refs['add-Accredited-modal'].show()
      Object.keys(this.newAccreditedData).forEach(key => {
        if (key === 'dateBirth') {
          this.newAccreditedData[key] = null
        } else {
          this.newAccreditedData[key] = ''
        }
      })
    },
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },

    formatPercentage (value, e) {
      value = value.replace(/\D/gm, '')
      let valueInt = parseInt(value)

      if (valueInt > 100) {
        value = '100'
      }

      if (valueInt < 1) {
        value = '1'
      }

      if (value !== '' && e.inputType !== 'deleteContentBackward') {
        value += '%'
      }
      return value
    },
    formatLazyPercentage (value) {
      let valueInt = parseInt(value)

      if (valueInt > 100) {
        value = '100'
      }

      if (valueInt < 0) {
        value = '1'
      }
      value += '%'
      return value
    },

    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }
        this.newAccreditedData.TelefoneComercial = this.newAccreditedData.TelefoneComercial.replace(/[().-]/gm, '')
        this.newAccreditedData.cep = this.newAccreditedData.cep.replace(/[().-]/gm, '')
        this.newAccreditedData.PercentualComissao = parseInt(this.newAccreditedData.PercentualComissao.replace('%', ''))
        AccrediteddateRepository.PostCredenciada(this.newAccreditedData)
          .then(res => {
            if (res.status === 200) {
              this.$refs['add-Accredited-modal'].hide()
              this.$emit('updateTableAccredited')
              toast.success(`Credenciada adicionado com sucesso`)
              loading.pop()
            }
          })
          .catch(() => {
            toast.error(`Erro ao adicionar Credenciada`)
            loading.pop()
          })
      })
    },
    cancelNewAccredited (e) {
      e.preventDefault()
      this.$refs['add-Accredited-modal'].hide()
      Object.keys(this.newAccreditedData).forEach(key => {
        if (key === 'dateBirth') {
          this.newAccreditedData[key] = null
        } else {
          this.newAccreditedData[key] = ''
        }
      })
    },
    searchAndress () {
      axios({
        method: 'GET',
        url: `https://viacep.com.br/ws/${this.newAccreditedData.cep}/json/`
      }).then(res => {
        if (!('erro' in res.data)) {
          let data = res.data
          if (res.status === 200) {
            this.newAccreditedData.CidadeNome = data.localidade
            this.newAccreditedData.Endereco = data.logradouro
            this.newAccreditedData.Bairro = data.bairro
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/newaccredited/newaccredited.js